import { useState } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { Modal } from 'components/DesignSystem/Modal';
import { UpdateRiskRegisterForm } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/UpdateRiskRegisterModal/components/UpdateRiskRegisterForm/UpdateRiskRegisterForm';

export const UpdateRiskRegisterModal = () => {
    const [showModal, setShowModal] = useState(true);
    const { pathname, search } = useLocation();
    const history = useHistory();

    const handleModalClose = () => {
        setShowModal(false);
        const pathWithoutParams = pathname.slice(0, pathname.lastIndexOf('/'));

        history.push({
            pathname: pathWithoutParams,
            search: search,
        });
    };
    return <UpdateRiskRegisterForm open={showModal} onClose={handleModalClose} />;
};
